<template>
    <v-navigation-drawer v-model="drawer"
                         app
                         right
                         clipped
                         color="grey--text white">
      
      <v-list dense
              class="ma-auto"
              align="center">
        <template v-for="(link, i) in links">
          <v-list-item v-if="link.name"
                       :key="i"
                       :to="link.route">
          <v-divider dark>
           </v-divider>
              <v-list-item-title class="grey--text font-weight-bold">
                {{ link.name }}
              </v-list-item-title>
          </v-list-item>
        </template>
      </v-list>
    </v-navigation-drawer>
</template>

<script>
export default {
    props:{
      drawer: Boolean,
      links: Array
    },
    methods:{
      closeall: function(event) {
        alert(event.target.tagName);
        this.$props.drawer = false;
        this.drawerRight = false
      }
    }
}
</script>